module.exports = __webpack_public_path__ + "static/media/logo.2415d9f7.jpg";